export const mapAntdSortOrder = (order: string | undefined) => {
  if (order === 'ascend') return 'asc';
  if (order === 'descend') return 'desc';
  return undefined;
};

export const mapToAntdSortOrder = (order: string | undefined) => {
  if (order === 'asc') return 'ascend';
  if (order === 'desc') return 'descend';
  return undefined;
};
